import React from "react";
import { DashboardLayout } from "../../components/DashboardLayout";
import { links } from "./ClinicAdminPages";
import IntegrationsCenter from "../../components/IntegrationsCenter";

export default function ClinicAdminIntegrations() {
  return (
    <DashboardLayout links={links} title="Integrations">
      <IntegrationsCenter scope="clinic" />
    </DashboardLayout>
  );
}
